import { Button, Stack } from '@mui/material'
import React from 'react'

import { StyledRouterLink } from 'components/common/StyledRouterLink'
import Icon from 'components/Icon'
import { useGetStatusChecksUrls } from 'components/status-checks/hooks/use-get-status-checks-urls'
import DeleteStatusCheck from 'components/status-checks/list/DeleteStatusCheck'
import { useStatusChecksContext } from 'context/status-checks/StatusChecksContext'
import toast from 'lib/toast'
import { type StatusCheck } from 'types/api/status-checks/status-check'

export const StatusCheckListActionCell: React.FC<{
  statusCheck: StatusCheck
}> = ({ statusCheck }) => {
  const statusChecksUrls = useGetStatusChecksUrls()

  const { refetch: reFetchStatusChecks } = useStatusChecksContext()

  return (
    <Stack direction="row" sx={{ alignItems: 'center', columnGap: 2 }}>
      <Button
        component={StyledRouterLink}
        data-test-edit-status-check={statusCheck.identifier}
        data-track-action="edit-status-check"
        data-track-category="status-checks" // TODO track anything different if it's PNI?
        data-track-on="click"
        size="small"
        startIcon={<Icon icon="edit" />}
        to={statusChecksUrls.edit(statusCheck.identifier)}
        variant="contained"
      >
        Edit
      </Button>
      <Button
        component={StyledRouterLink}
        data-test-clone-status-check={statusCheck.identifier}
        data-track-action="clone-status-check"
        data-track-category="status-checks" // TODO track anything different if it's PNI?
        data-track-on="click"
        size="small"
        startIcon={<Icon icon="clone" />}
        state={{
          statusCheck: { ...statusCheck, identifier: null }
        }}
        to={statusChecksUrls.new()}
        variant="contained"
      >
        Clone
      </Button>
      <DeleteStatusCheck
        statusCheck={statusCheck}
        onChanged={async () => {
          toast({
            type: 'success',
            text: `Successfully deleted Health Check ${statusCheck.name}`
          })
          await reFetchStatusChecks()
        }}
      />
    </Stack>
  )
}
